/* LODISIA — Holiday Launch Sale display, limited to the real discount window.
   Dates match the Shopify automatic discount "Holiday Launch Sale – 50% Off":
   Oct 24 00:00 → Oct 28 23:59, America/Mexico_City (UTC-6) = 2026-10-24T06:00Z → 2026-10-29T05:59Z.
   Before and after, nothing changes: normal price and the usual announcement bar. */
(function () {
  'use strict';
  var SALE = {
    start: Date.parse('2026-10-24T06:00:00Z'),
    end: Date.parse('2026-10-29T05:59:00Z'),
    text: 'HOLIDAY LAUNCH SALE – 50% OFF – ENDS OCT 28'
  };

  // Preview only: ?lod_preview_date=2026-10-24T12:00:00-06:00 simulates that moment for the current visitor.
  var offset = 0;
  try {
    var p = new URLSearchParams(location.search).get('lod_preview_date');
    if (p && !isNaN(Date.parse(p))) offset = Date.parse(p) - Date.now();
  } catch (e) {}
  function now() { return Date.now() + offset; }
  function isOn() { var t = now(); return t >= SALE.start && t < SALE.end; }

  var bar, original, timer;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function countdown() {
    var ms = Math.max(0, SALE.end - now());
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
  }
  function render() {
    if (!isOn()) { stop(); return; }
    var el = bar && bar.querySelector('[data-lod-countdown]');
    if (el) el.textContent = countdown();
  }
  function start() {
    document.documentElement.classList.add('lod-sale-on');
    bar = document.querySelector('.announcement-bar__message');
    if (bar) {
      original = bar.innerHTML;
      bar.innerHTML = '<span>' + SALE.text + '</span><span class="lod-countdown">Ends in <span data-lod-countdown>' + countdown() + '</span></span>';
    }
    timer = setInterval(render, 1000);
  }
  function stop() {
    document.documentElement.classList.remove('lod-sale-on');
    if (bar && original != null) bar.innerHTML = original;
    if (timer) clearInterval(timer);
  }
  function init() {
    if (isOn()) { start(); return; }
    // Page left open before the sale starts: switch on at the exact start time (if within 24h).
    var wait = SALE.start - now();
    if (wait > 0 && wait < 86400000) setTimeout(function () { if (isOn()) start(); }, wait + 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
